module.exports = __webpack_public_path__ + "img/blueManage.11791e8f.svg";